<mat-card>
    <mat-card-content>
        <div *ngIf="form && detailBcInfo">
            <div class="row" style="padding: 0px;"  [formGroup]="form">
                <div class="col-sm-4" style="padding: 0px;">
                    <div class="header-class">
                        Commande
                    </div>
                    <div class="data-class row">
                        <div class="col-sm-12">
                            <mat-form-field matTooltip="Désignation ou titre du BC"  class="full-width">
                                <mat-label>Désignation BC</mat-label>
                                <input matInput required name="nth-libelle-bc" formControlName="libelle" />
                                <mat-error *ngIf="form.get('libelle').hasError('maxlength')">
                                    Nombre maximum de caractère dépassé
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field matTooltip="Statut du BC"  class="full-width">
                                <mat-label>Statut</mat-label>
                                <input matInput required name="nth-libelle-bc" formControlName="status" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field matTooltip="Date du Bon de commande" class="full-width">
                                <mat-label>Date</mat-label>
                                <input required matInput [matDatepicker]="pickerD" 
                                 name="nth-date-bc" [min]="minDate" [max]="maxDate" formControlName="dBc"
                                 >
                                <mat-datepicker-toggle matSuffix [for]="pickerD"></mat-datepicker-toggle>
                                <mat-datepicker #pickerD></mat-datepicker>
                                <mat-error *ngIf="form.get('dBc').hasError('matDatepickerMin')">
                                    Date trop basse
                                </mat-error>
                                <mat-error *ngIf="form.get('dBc').hasError('matDatepickerMax')">
                                    Date trop haute
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <app-autocomplete-with-code-libelle-form [parent]="form" libelle="Site"
                                [objets]="detailBcInfo.sites" codeControlName="codeSite"
                                libelleControlName="libelleSite">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                        <div class="col-sm-6" *ngIf="form.get('type').value !== definitionTypeBC.BCEnveloppe">
                            <mat-form-field class="full-width">
                                <mat-label>Date de livraison prévisionnelle</mat-label>
                                <input required matInput [matDatepicker]="pickerDLivr" name="nth-date-bc"
                                    formControlName="dLivraison">
                                <mat-datepicker-toggle matSuffix [for]="pickerDLivr"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDLivr></mat-datepicker>
                                <mat-error *ngIf="form.get('dLivraison').hasError('matDatepickerMin')">
                                    Date de livraison inférieur a la date du BC
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6" *ngIf="form.get('type').value === definitionTypeBC.BCEnveloppe">
                            <mat-form-field class="full-width">
                                <mat-label>Date de fin de validité</mat-label>
                                <input required matInput [matDatepicker]="pickerDFinV" name="nth-date-fin"
                                    formControlName="dFinValid" [min]="minDateFinValide">
                                <mat-datepicker-toggle matSuffix [for]="pickerDFinV"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDFinV></mat-datepicker>
                                <mat-error *ngIf="form.get('dFinValid').hasError('matDatepickerMin')">
                                    Date de fin de validité inférieur a la date du BC
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <app-autocomplete-with-code-libelle-form [parent]="form" libelle="Site de livraison"
                                [objets]="detailBcInfo.sites" codeControlName="codeSiteLivraison"
                                libelleControlName="libelleSiteLivraison">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                        <div class="col-sm-6">
                            <app-autocomplete-with-code-libelle-form [parent]="form" matTooltip="Agence P1P2" libelle="CA1" required
                                [objets]="detailBcInfo.ca1s" codeControlName="codeCa1" libelleControlName="libelleCa1">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" style="padding: 0px;">
                    <div class="header-class">
                        Fournisseur
                    </div>
                    <div class="data-class row">

                        <div class="col-sm-8" style="padding: 0px;">
                            <div class="row" style="margin: 0px;">

                                <div [ngClass]="form.controls['codeFourn'].disabled ? 'col-sm-12' : 'col-sm-11'"  style="padding-right: 0px;">
                                    <app-autocomplete-with-code-libelle-form name="libelleFourn" [parent]="form"
                                        libelle="Fournisseur" [objets]="detailBcInfo.fournisseurs"
                                        codeControlName="codeFourn" libelleControlName="libelleFourn">
                                    </app-autocomplete-with-code-libelle-form>
                                </div>
                                <div class="col-sm-1" *ngIf="!form.controls['codeFourn'].disabled">
                                    <mat-icon type="submit" (click)="openModalFournisseur()" id="search">search</mat-icon>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width" matTooltip="Visible sur la version papier (ex: le numéro de devis ou préfac du fournisseur)">
                                        <mat-label>Ref externe</mat-label>
                                        <input matInput name="nth-ref-fourn" formControlName="refFourn">
                                    </mat-form-field>
                                </div>
                               
                                <div class="col-sm-6">
                                    <app-autocomplete-with-code-libelle-form name="libelleCondRegl" [parent]="form"
                                        articlePrefix="la "
                                        libelle="Condition de règlement" [objets]="detailBcInfo.condRegls"
                                        codeControlName="codeCondRegl" libelleControlName="libelleCondRegl">
                                    </app-autocomplete-with-code-libelle-form>
                                </div>
                                <div class="col-sm-6">
                                    <app-autocomplete-with-code-libelle-form name="libelleModeRegl" [parent]="form"
                                        libelle="Mode de règlement" [objets]="detailBcInfo.modeRegls"
                                        codeControlName="codeModeRegl" libelleControlName="libelleModeRegl">
                                    </app-autocomplete-with-code-libelle-form>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width"  matTooltip="Numéro de BC / chantier JASON limité à 13 caractères">
                                        <mat-label>Code chantier</mat-label>
                                        <input matInput name="nth-code-chantier" formControlName="chantier">
                                        <mat-error *ngIf="form.get('chantier').hasError('maxlength')">
                                            Nombre maximum de caractère dépassé.
                                        </mat-error>
                                        <mat-error *ngIf="form.get('chantier').hasError('pattern')">
                                            Le format est incorrect
                                          </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width" matTooltip="Visible sur la version papier, permet des ajouts spécifiques aux mentions légales">
                                        <mat-label>Mention</mat-label>
                                        <input matInput name="nth-ref-mention" formControlName="mention">
                                        <mat-error *ngIf="form.get('mention').hasError('maxlength')">
                                            Nombre maximum de caractère dépassé.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" style="padding-left: 0px;padding-top: 0.1em;">
                            <mat-form-field class="full-width" matTooltip="Visible sur la version papier, contient des commentaires liés au BC" >
                                <mat-label style="margin-left: 5px;">Observation</mat-label>
                                <textarea matInput name="nth-ref-obs" cdkTextareaAutosize cdkAutosizeMinRows="8"
                                    cdkAutosizeMaxRows="10" style="background-color: white;"
                                    formControlName="commentaires"></textarea>
                                <mat-error *ngIf="form.get('commentaires').hasError('maxlength')">
                                    Nombre maximum de caractère dépassé.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="full-width" *ngIf="form.get('type').value !== definitionTypeBC.BCEnveloppe"
                            matTooltip="Numéro dans un autre logiciel en cas de reprise ou référençant le n° du BC d'origine pour les BC de régularisation (indispensable à ESKER) " >
                                <mat-label>N° BC Amont</mat-label>
                                <input matInput name="nth-bcAmont" formControlName="bcAmont">
                                <mat-error *ngIf="form.get('bcAmont').hasError('maxlength')">
                                    Nombre maximum de caractère dépassé.
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </div>
                <div class="col-sm-2" id="totaux">
                    <div class="header-class">
                        Totaux
                    </div>
                    <div class="data-class row" *ngIf="form.value.bcLines" style="padding: 5px;">
                        <table>
                            <caption></caption>
                            <th></th>
                            <tbody>
                                <tr >
                                    <td class="align-cell-left"> Total HT :</td>

                                    <td class="align-cell-right"
                                        *ngIf="amountHT.toFixed(2).toString() === '0' ; else getHtNull"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getHtNull>
                                        <td class="align-cell-right"> {{amountHT.toFixed(2).toString() |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left">Total TVA : </td>
                                    <td class="align-cell-right"
                                        *ngIf="amountTVA.toFixed(2).toString() === '0' ; else getTvaNull"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getTvaNull>
                                        <td class="align-cell-right">{{amountTVA.toFixed(2).toString() |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>

                                <tr>
                                    <td class="align-cell-left">Livré : </td>
                                    <td class="align-cell-right"
                                        *ngIf="sumHtLivre === 0 ; else htlivre"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #htlivre>
                                        <td class="align-cell-right">{{sumHtLivre |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left">Non livré : </td>
                                    <td class="align-cell-right"
                                        *ngIf="sumNonLivre === 0 ; else getnonlivreNull"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getnonlivreNull>
                                        <td class="align-cell-right">{{sumNonLivre |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left">Livré non provisionné : </td>
                                    <td class="align-cell-right"
                                        *ngIf="sumLivreNonprovisionne === 0 ; else getLivreNonprovisionneNull"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getLivreNonprovisionneNull>
                                        <td class="align-cell-right">{{sumLivreNonprovisionne |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left">Déprovisionné : </td>
                                    <td class="align-cell-right"
                                        *ngIf="sumDeprovionne === 0 ; else getDeprovisNull"> {{'0' |
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getDeprovisNull>
                                        <td class="align-cell-right">{{sumDeprovionne |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left" matTooltip="HT Provisionné sans contrepartie" matTooltipPosition="left" matTooltipClass="error-tooltip">Solde : </td>
                                    <td class="align-cell-right"
                                        *ngIf="sumEncours === 0 ; else getEncoursNull"> {{'0' | 
                                        currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getEncoursNull>
                                        <td class="align-cell-right">{{sumEncours |
                                            currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class=" data-class row"  *ngIf="!this.documents || this.documents.length === 0 && form.get('type').value !== definitionTypeBC.BCEnveloppe">
                        <table>
                            <caption></caption>
                            <th></th>
                            <tbody>
                                <div class="col-sm-12 checkbox" *ngIf="router.url.includes('/brouillon-bc')">
                                    <label class="container">Sans document
                                        <input type="checkbox"
                                        [checked]="this.withoutDoc" (change)="onChange()" >
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-4" *ngIf="showDocuments">
                            <button type="button" mat-raised-button (click)="showBcDocuments()" matTooltip="Lister les documents">
                                <mat-icon>description_outline</mat-icon>
                            </button>
                        </div>
                        <div class="col-sm-4" *ngIf="router.url.includes('/brouillon') && !withoutDoc">
                            <button type="button" mat-raised-button (click)="showAddDocument()" matTooltip="Ajouter un document">
                                <mat-icon>note_add</mat-icon>
                            </button>
                        </div>
                        <div class="col-sm-4" *ngIf="router.url.includes('/brouillon-bc') && !withoutDoc">
                            <button type="button" mat-raised-button (click)="showAddDriveDocument()"  matTooltip="Ajouter un document depuis Google Drive">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
